import EventHub from '@/app/game/handlers/EventHub';

export default class GameObj
{
    constructor( settings )
    {
        this.eventHub = EventHub;
        this.score = 0;
        this.pos = { x: 0, y: 0 };

        if( settings.x && settings.y )
        {
            this.pos.x = settings.x;
            this.pos.y = settings.y;
        }

        this.type = null;
    }
}



// WEBPACK FOOTER //
// ./src/app/game/elements/GameObj.js